import { DURATION_VALUES } from "../../types/article";
import type { DurationValue } from "../../types/article";

interface DurationDropdownProps {
  value: DurationValue | "";
  onChange: (value: DurationValue) => void;
}

export function DurationDropdown({ value, onChange }: DurationDropdownProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value) as DurationValue)}
      className={`flex-1 h-[51px] px-4 rounded-2xl border border-stroke-primary bg-bg-primary text-base appearance-none cursor-pointer focus:outline-none focus:border-brand-brown ${
        value ? "text-text-primary" : "text-text-tertiary"
      }`}
    >
      <option value="" disabled>
        Duration
      </option>
      {DURATION_VALUES.map((d) => (
        <option key={d} value={d}>
          {d} min
        </option>
      ))}
    </select>
  );
}
